import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import "../styles/resume.css"

// Tell react-pdf where to find the PDF.js worker.
// Must be set in this same file (not a separate config file).
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

const RESUME_URL="/resume.pdf";

function Resume() {

    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    return (
    <main className="min-h-screen">
        <div className="max-w-6xl mx-auto px-6 py-20">
            <section className="border rounded mx-auto bg-white mb-20 p-8">
                <a href={RESUME_URL} download className="resume-download-btn hover:bg-gray-700">
                    Download PDF
                </a>

                <Document
                    file={RESUME_URL}
                    onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                    loading="Loading resume…"
                    error="Couldn't load the PDF — try downloading it instead."
                >
                    <Page pageNumber={pageNumber} width={1000} />
                </Document>

            {numPages && (
        <div className="resume-nav">
            <button
                disabled={pageNumber <= 1}
                onClick={() => setPageNumber((p) => p - 1)}
            >
                ← Prev
            </button>
            <span>
                Page {pageNumber} of {numPages}
            </span>
            <button
                disabled={pageNumber >= numPages}
                onClick={() => setPageNumber((p) => p + 1)}
            >
                Next →
            </button>
            </div>
        )}
            </section>
        </div>
    </main>    
    );
}

export default Resume;
